// src/routes/global.tsx
import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import { EEntity, EModule } from "@/components/table/filter/useTables";

const PageUsers = React.lazy(() => import("@/modules/global/pages/users").then(m => ({ default: m.PageUsers })));
const PageProfiles = React.lazy(() => import("@/modules/global/pages/profiles").then(m => ({ default: m.PageProfiles })));
const PageJob = React.lazy(() => import("@/modules/global/pages/jobs/id").then(m => ({ default: m.PageJob })));
const PageTickets = React.lazy(() => import("@/modules/helpDesk/pages/tickets"));
const PageFormBuilder = React.lazy(() => import("@/modules/helpDesk/pages/formsNoc"));

// ----------------------------------------------
// Helper: embrulha no ProtectedRoute (GLOBAL)
// ----------------------------------------------
type Def = {
  path: string;
  element: React.ReactElement;
  auth: boolean;           // mantido p/ consistência (todas aqui são true)
  entity: EEntity;
};

const wrap = ({ auth, entity, element }: Omit<Def, "path">) => (
  <React.Suspense fallback={<>Carregando...</>}>
    <ProtectedRoute
      auth={auth}
      {...(auth ? { module: EModule.HELPDESK, entity } : {})}
    >
      {element}
    </ProtectedRoute>
  </React.Suspense>
);

const tickets: Def[] = [
  { path: "/helpDesk/tickets", auth: true, entity: EEntity.HD_TICKETS, element: <PageTickets /> },
];

const formsNoc: Def[] = [
  { path: "/helpDesk/forms", auth: true, entity: EEntity.HD_FORMS, element: <PageFormBuilder /> },
];

const formNoc: Def[] = [
  { path: "/helpDesk/forms/:idForm", auth: true, entity: EEntity.HD_FORMS, element: <PageJob /> },
];

const defs: Def[] = [
  ...tickets,
  ...formsNoc,
  ...formNoc,
];

export const helpDeskRoutes = defs.map(({ path, ...rest }) => (
  <Route key={path} path={path} element={wrap(rest)} />
));
